// extracted by mini-css-extract-plugin
export default {"input":"SuperInput_input__ke2Ya","text":"SuperInput_text__YeC6e"};